import React, { Component } from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PopupCloseIcone from '../../comum/components/PopupCloseIcone';

export default class Popup extends Component {

    constructor(props) {
        super(props)
    }

    render() {
        if (this.props.isOpen) {
            return (
                <div style={{ top: this.props.y || 0, left: this.props.x }} className={`popup popup--open__${this.props.isOpen} ${this.props.className} ${this.props.table && 'popup--table'}`}>
                    <div className="popup--header">
                        <div>
                            {this.props.title}
                            <div className='popup--close-button' onClick={this.props.onClick}>
                                <PopupCloseIcone className="popup--close-button__icon" />
                            </div>

                        </div>

                    </div>
                    {this.props.information && <div className="popup--information">{this.props.information}</div>}
                    {this.props.children}
                </div>
            )
        } else {
            return null
        }
    }
}



// WEBPACK FOOTER //
// ./src/modules/comum/components/Popup.js